import { jsx, jsxs } from "react/jsx-runtime";
import CssBaseline from "@mui/material/CssBaseline";
import GlobalStyles from "@mui/material/GlobalStyles";
import { useTheme } from "@mui/material/styles";
import { Experimental_CssVarsProvider as CssVarsProvider, useColorScheme } from "@mui/material/styles/CssVarsProvider";
import merge from "lodash/merge";
import React from "react";
import {
  getTheme,
  GLOBAL_STYLES
} from "../../theme";
import "../../assets/fonts/stylesheet.css";
const DEFAULT_MODE_STORAGE_KEY = "dion-web-theme-mode";
const ThemeProvider = (props) => {
  const {
    children,
    defaultMode,
    theme: customTheme,
    globalStyles,
    forceCustomTheme,
    modeStorageKey = DEFAULT_MODE_STORAGE_KEY
  } = props;
  const theme = React.useMemo(
    () => getTheme(customTheme, forceCustomTheme),
    [customTheme, forceCustomTheme]
  );
  const styles = React.useMemo(
    () => merge(GLOBAL_STYLES, globalStyles || {}),
    [globalStyles]
  );
  return /* @__PURE__ */ jsxs(CssVarsProvider, { theme, defaultMode, modeStorageKey, children: [
    /* @__PURE__ */ jsx(CssBaseline, { enableColorScheme: true }),
    styles && /* @__PURE__ */ jsx(GlobalStyles, { styles }),
    children
  ] });
};
var ThemeProvider_default = ThemeProvider;
export {
  ThemeProvider_default as default,
  useColorScheme,
  useTheme
};
